import BaseComponent from 'scripts/BaseComponent.js';

export default class CollectionFooter extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      viewToggleBtn: '.js-collectionFooterToggleView',
      collapsibleText: '.js-collapsibleText',
      collapsibleImage: '.js-collapsibleImage',
    };

    this.dom = {
      $component: component,
      $viewToggleBtn: this.$get(this.refs.viewToggleBtn),
      $collapsibleText: this.$get(this.refs.collapsibleText),
      $collapsibleImage: this.$get(this.refs.collapsibleImage),
    };

    this.state = {
      isExpanded: false,
      isExpandedClass: 'is-expanded',
      animationDuration: 500,
      breakpoint: '(min-width: 1200px)',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    if (!dom.$viewToggleBtn) return;
    this.setClick(dom.$viewToggleBtn, this.toggleView);
  }

  toggleView() {
    const { state } = this;

    if (state.isExpanded) {
      this.collapiseView();
    } else {
      this.expandView();
    }
  }

  expandView() {
    const { dom, state } = this;
    const textContentHeight = dom.$collapsibleText.scrollHeight;

    dom.$component.classList.add(state.isExpandedClass);
    dom.$collapsibleText.style.maxHeight = `${textContentHeight}px`;

    if (this.isDesktop()) {
      const imageContentHeight = dom.$collapsibleImage.scrollHeight;
      dom.$collapsibleImage.style.maxHeight = `${imageContentHeight}px`;
    }

    dom.$viewToggleBtn.setAttribute('aria-expanded', 'true');
    this.setToggleBtnText('View less');
    state.isExpanded = true;
  }

  async collapiseView() {
    const { dom, state } = this;

    dom.$collapsibleText.style.maxHeight = this.getTextMinHeight();

    if (this.isDesktop()) {
      dom.$collapsibleImage.style.maxHeight = '200px';
    }

    setTimeout(() => {
      dom.$component.classList.remove(state.isExpandedClass);
    }, state.animationDuration);

    dom.$viewToggleBtn.setAttribute('aria-expanded', 'false');
    this.setToggleBtnText('View more');
    state.isExpanded = false;
  }

  setToggleBtnText(text) {
    const { dom } = this;

    dom.$viewToggleBtn.querySelector('span').textContent = text;
  }

  isDesktop() {
    const { state } = this;

    return window.matchMedia(state.breakpoint).matches;
  }

  getTextMinHeight() {
    return this.isDesktop() ? '95px' : '115px';
  }
}
